import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'
import RadioGroup from '../../../../../UI/RadioGroup/RadioGroup'

const Portfolio = ({ widthInPercent }) => {
  const translations = useSelector((state) => state.translations)
  const settings = useSelector((state) => state.settings)
  const newObject = useSelector((state) => state.OBJECT)
  const dispatch = useDispatch()

  const update = (value) => {
    const updatePurchaseProfile = { ...newObject, portfolio: value }
    // dispatch(setNewObject(updatePurchaseProfile))
    dispatch(setLocal(props.OBJECT, updatePurchaseProfile))
  }

  if (!settings || !newObject || !translations) return <></>

  return (
    <div className="wrapper" style={{ width: `${widthInPercent}%` }}>
      <div className="group">
        <div className="element">
          <div className="label">{translations['object.deal-criteria.portfolio']}</div>
          <div className="values">
            <RadioGroup
              options={settings.getGroup('radiogroup.default.options').map((option) => ({ value: translations[option.translationKey], key: option.key }))}
              values={newObject.dealCriteria.investmentType}
              onChange={update}
              itemsPerRow={3}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Portfolio
